import * as R from "ramda";

import { validators as chatbotValidators } from "../../../../../../components/Chatbot";
import i18n from "../../../../../../i18n";

/*
  For now, screening fixed options and screening fixed questions are assumed to be boolean only.
  If that changes, the respective component used to render the option should change, as well as the submit method of this form
  and the request to create opportunities (that also filters fixed questions based on their boolean state).
*/

// This is for any keys that are not included in opportunity.questionsAdvanced[]
// The key is the same key that will be sent and the value is the initial state.
export const SCREENING_FIXED_OPTIONS = {
  englishTestRequired: false
};

// This is for any keys that are included in opportunity.questionsAdvanced[]
// The key is the type of the question that will be sent and the value is the initial state.
export const SCREENING_FIXED_QUESTIONS = {
  salary: {
    enabled: false,
    configurable: true,
    knockout: false,
    validRange: undefined,
    isValid: R.anyPass([
      R.allPass([
        R.propEq("knockout", false),
        R.propSatisfies(R.isNil, "validRange")
      ]),
      R.allPass([
        R.propEq("knockout", true),
        R.propSatisfies(
          R.allPass([
            R.all(
              R.compose(
                R.not,
                R.isNil
              )
            ),
            R.converge(R.gt, [R.prop(1), R.prop(0)])
          ]),
          "validRange"
        )
      ])
    ]),
    tooltipError: i18n.t("opportunity:screening.salaryInvalid")
  },
  referral: {
    enabled: true
  },
  chatbot: {
    enabled: false,
    config: {
      chatTree: {
        questions: []
      }
    },
    hasInitialError: chatbotValidators.getErrorText(
      R.path(chatbotValidators.INITIAL_CHATBOT_VALIDATION_PATH)
    ),
    isEmpty: R.compose(
      R.isEmpty,
      R.pathOr([], chatbotValidators.INITIAL_CHATBOT_VALIDATION_PATH, R.__)
    ),
    configurable: true,
    tooltipError: i18n.t("opportunity:screening.chatbotInvalidConversation")
  }
};

export const FIXED_OPTIONS_KEYS = R.keys(SCREENING_FIXED_OPTIONS);
export const FIXED_QUESTIONS_KEYS = R.keys(SCREENING_FIXED_QUESTIONS);

export const isFixedOption = R.compose(
  R.includes(R.__, FIXED_OPTIONS_KEYS),
  R.prop("type")
);

export const isFixedQuestion = R.compose(
  R.includes(R.__, FIXED_QUESTIONS_KEYS),
  R.prop("type")
);

export const isConfigurableOption = R.propEq("configurable", true);

export const questionHasError = R.prop("error");
export const questionIsInvalid = question =>
  question.isValid && !question.isValid(question);

// Checks for questions that are configurable and are invalid
const invalidConfigQuestion = R.allPass([
  isConfigurableOption,
  questionHasError
]);

// Checks for invalid questions that are enabled
const invalidChatbotEnabledQuestion = R.allPass([
  R.propEq("type", "chatbot"),
  R.propEq("configurable", true),
  R.propEq("enabled", true),
  record => record.isEmpty && record.isEmpty(record)
]);

export const hasInvalidScreeningQuestions = R.anyPass([
  invalidChatbotEnabledQuestion,
  invalidConfigQuestion
]);

export const hasInvalidScreeningConfig = R.allPass([
  questionIsInvalid,
  invalidConfigQuestion
]);

export const disableInvalidQuestions = R.when(
  hasInvalidScreeningQuestions,
  R.assoc("enabled", false)
);
